import { render, staticRenderFns } from "./TopNavigation.vue?vue&type=template&id=1a07cff8&"
import script from "./TopNavigation.vue?vue&type=script&lang=js&"
export * from "./TopNavigation.vue?vue&type=script&lang=js&"
import style0 from "./TopNavigation.vue?vue&type=style&index=0&id=1a07cff8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports